// Dressings data
const dressings = [
  {
    id: 1,
    name: 'No Dressing'
  },
  {
    id: 2,
    name: 'Yellow Mustard'
  },
  {
    id: 3,
    name: 'Spicy Mustard'
  },
  {
    id: 4,
    name: 'Dijon Mustard'
  },
  {
    id: 5,
    name: 'Honeycup Mustard'
  },
  {
    id: 6,
    name: 'Mayo'
  },
  {
    id: 7,
    name: 'Miracle Whip'
  },
  {
    id: 8,
    name: 'Russian Dressing'
  },
  {
    id: 9,
    name: 'Ketchup'
  },
  {
    id: 10,
    name: 'BBQ Sauce'
  },
  {
    id: 11,
    name: 'Ranch'
  },
  {
    id: 12,
    name: 'Italian'
  },
  {
    id: 13,
    name: 'Horseradish'
  },
  {
    id: 14,
    name: 'Honey Mustard'
  }
];

export default dressings;